const socialLinks = 
    {
    facebook: "#",
    twitter: "#", 
    instagram: "#"         
    
}


export default socialLinks;